const state = {
  saleSkinModalVisible: false,
  offerDetailsModalVisible: false,
  acceptOfferModalVisible: false,
};

const mutations = {
  openSaleSkinModal(state) {
    state.saleSkinModalVisible = true;
  },
  closeSaleSkinModal(state) {
    state.saleSkinModalVisible = false;
  },
  openOfferDetailsModal(state, offer) {
    this.commit('offer/setSelectedOffer', offer);
    state.offerDetailsModalVisible = true;
  },
  closeOfferDetailsModal(state) {
    state.offerDetailsModalVisible = false;
  },
  openAcceptOfferModal(state, offer) {
    this.commit('offer/setSelectedOffer', offer);
    state.acceptOfferModalVisible = true;
  },
  closeAcceptOfferModal(state) {
    state.acceptOfferModalVisible = false;
  },
};

const actions = {
  openSaleSkinModal({ commit }) {
    commit('openSaleSkinModal');
  },
  closeSaleSkinModal({ commit }) {
    commit('closeSaleSkinModal');
  },
  openOfferDetailsModal({ commit }, offer) {
    commit('openOfferDetailsModal', offer);
  },
  closeOfferDetailsModal({ commit }) {
    commit('closeOfferDetailsModal');
  },
  openAcceptOfferModal({ commit }, offer) {
    commit('openAcceptOfferModal', offer);
  },
  closeAcceptOfferModal({ commit }) {
    commit('closeAcceptOfferModal');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
